import CustomerOrderItemStatusBadge from 'domains/customer-order/atoms/item-status-badge'
import PropTypes from 'prop-types'
import { Button, Table } from 'reactstrap'
import PriceUtil from 'utils/price-util'
import { useHistory } from 'react-router'

const propTypes = {
  orderItem: PropTypes.shape({
    id                : PropTypes.number,
    customer_order_id : PropTypes.number,
    sku               : PropTypes.string,
    quantity          : PropTypes.number,
    discount_amount   : PropTypes.number,
    price             : PropTypes.number,
    status            : PropTypes.string,
    image             : PropTypes.string,
    name              : PropTypes.string
  })
}

const defaultProps = {
  orderItem: {
    quantity        : 0,
    discount_amount : 0,
    price           : 0,
    status          : '',
    image           : '',
    name            : ''
  }
}

/**
 * Multi-purpose Customer Order Item view.
 * It display about the order item information
 * @param {object} customerOrderItem
 */
const CustomerOrderItemView = ({ orderItem }) => {
  const history = useHistory()

  const redirect = (order_id) => {
    history.push({
      pathname: `/app/customer-orders/${order_id}`
    })
  }

  return (
    <>
      { /** Product (main information) */ }
      <Table bordered className='mt-4'>
        <tbody>
          <tr>
            <th scope='row'>ID</th>
            <td>{ orderItem.id }</td>
          </tr>
          <tr>
            <th scope='row'>Quantity</th>
            <td>{ orderItem.quantity }</td>
          </tr>
          <tr>
            <th scope='row'>Status</th>
            <td>{ <CustomerOrderItemStatusBadge status={ orderItem.status } /> }</td>
          </tr>
          <tr>
            <th scope='row'>Price</th>
            <td>
              { PriceUtil.format(orderItem.price) }
            </td>
          </tr>
          <tr>
            <td colSpan='2'>
              <Button
                className='float-right'
                size='sm'
                onClick={ () => redirect(orderItem.customer_order_id) }
                color='primary'
              >
                { 'Go to Order Detail' }
              </Button>
            </td>
          </tr>
        </tbody>
      </Table>
    </>
  )
}

CustomerOrderItemView.propTypes    = propTypes
CustomerOrderItemView.defaultProps = defaultProps

export default CustomerOrderItemView
